/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { AccountState } from '../models/AccountState';

export class CustomerVaultAccount {
  /**
  * Eon-assigned vault account ID.
  */
  'id': string;
  /**
  * Cloud-provider-assigned account ID.
  */
  'providerAccountId': string;
  'status': AccountState;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "id",
      "baseName": "id",
      "type": "string",
      "format": ""
    },
    {
      "name": "providerAccountId",
      "baseName": "providerAccountId",
      "type": "string",
      "format": ""
    },
    {
      "name": "status",
      "baseName": "status",
      "type": "AccountState",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return CustomerVaultAccount.attributeTypeMap;
  }

  public constructor() {
  }
}



